import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../Button/Button';
import './LandingHero.css';
import textaScreenshot from '../../../image-assets/texta-screenshot.png';

const LandingHero = () => {
  // Function to scroll to the first audience section
  const handleScrollToFeatures = () => {
    const featuresSection = document.getElementById('writers');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <header className="landing-hero-section">
      <div className="hero-screenshot-container">
        <img 
          src={textaScreenshot} 
          alt="Texta Web Editor Screenshot" 
          className="hero-screenshot-image"
        />
      </div>
      <h1 className="landing-hero-title">Write Better, Translate Faster, Ship Smoother.</h1>
      <p className="landing-hero-subtitle">
        Texta streamlines your team's writing, translation, and localization workflow.
      </p>
      {/* Container for action buttons */}
      <div className="hero-actions">
        <Link to="/signup" className="landing-hero-cta-link">
          <Button variant="primary" size="xlarge">
            Try for free
          </Button>
        </Link>
      </div>
    </header>
  );
};

export default LandingHero; 